class NotifyLostCartRecovery extends HTMLElement {
  constructor() {
    super();

    this.storageKeyAuthenticationState = 'NotifyLostCartRecovery.has-been-authenticated';
  }

  connectedCallback() {
    const userIsAuthenticated = this.dataset.userIsAuthenticated === 'true';
    if (userIsAuthenticated) {
      localStorage.setItem(this.storageKeyAuthenticationState, 'true');
      return;
    }

    const cartIsEmpty = this.dataset.cartIsEmpty;
    const hasBeenAuthenticated = localStorage.getItem(this.storageKeyAuthenticationState) === 'true';
    if (!hasBeenAuthenticated || !cartIsEmpty) {
      return;
    }

    this.popupTimeout = setTimeout(() => {
      localStorage.removeItem(this.storageKeyAuthenticationState);

      const signinLink = this.dataset.signinLink;

      publish(PUB_SUB_EVENTS.toastOpen, {
        message: `<div>
                    Did you have products in your cart?
                    <div>
                        Recover them by <a href="${signinLink}">signing in</a>.
                    </div>
                </div>`,
        status: 'info',
        closeMs: 7000,
      });
    }, 3000);
  }

  disconnectedCallback() {
    if (this.popupTimeout) {
      clearTimeout(this.popupTimeout);
    }
  }
}

customElements.define('notify-lost-cart-recovery', NotifyLostCartRecovery);
